import React, { useEffect, useState } from 'react';
import { Section } from '@zurich-base-ui/layout.section';
import { Button } from '@zurich-primitives/button';
import { sendFeedback } from 'integration';
import { IFeedback } from 'app/utils';
import { setFeedbackConfirmation, useAppDispatch } from 'app/redux';
import styles from './SomethingMissing.module.scss';
import { FeedbackConfirmation } from 'app/components';

export const SomethingMissing: React.FC = () => {
  const dispatch = useAppDispatch();
  const [comments, setComments] = useState<string | undefined>();
  const [typeOfBussiness, setTypeOfBussiness] = useState<string | undefined>();
  const [typeOfServices, setTypeOfServices] = useState<string | undefined>();

  useEffect(() => {
    clearFeedbackForm();
  }, []);

  const clearFeedbackForm = (): void => {
    setComments('');
    setTypeOfBussiness('');
    setTypeOfServices('');
  };

  const handleSubmit = (): void => {
    const feedback: IFeedback = {
      origin: 'missing-something-feedback',
      businessArea: typeOfBussiness,
      businessService: typeOfServices,
      feedback: comments ?? ''
    };
    sendFeedback(feedback)
      .then((response) => {
        response !== undefined && dispatch(setFeedbackConfirmation(true));
      })
      .finally(() => {
        clearFeedbackForm();
      });
  };

  return (
    <Section className={styles.section}>
      <h2 className="highlight">Let us know what we are missing</h2>
      <p className={`body-sm-r`}>
        To help us get better, please provide this information
      </p>
      <div className={styles.wrapper}>
        <input
          type="text"
          placeholder="Business Area"
          className={styles['text-area']}
          spellCheck="false"
          onChange={(e) => setTypeOfBussiness(e.target.value)}
          value={typeOfBussiness ?? ''}
        />
        <input
          type="text"
          placeholder="Service or document type"
          className={styles['text-area']}
          spellCheck="false"
          onChange={(e) => setTypeOfServices(e.target.value)}
          value={typeOfServices ?? ''}
        />
        <textarea
          placeholder="Describe the action you would like to perform"
          className={styles['text-area']}
          spellCheck="false"
          onChange={(e) => setComments(e.target.value)}
          value={comments ?? ''}
        />
      </div>
      <div className={`${styles.modalButtons}`}>
        <Button onClick={handleSubmit} disabled={!comments || comments === ''}>
          Submit
        </Button>
      </div>
      <FeedbackConfirmation />
    </Section>
  );
};

export default SomethingMissing;
